import { Features, isFeatureEnabled } from '../../../featureToggles/features';
import { isProductionEnv } from '../../../utils/platform';
import { BlockedByFeature } from '../../../featureToggles/features/utils';

export enum AccessTypes {
  /** @deprecated */
  Trial = 'TRIAL',
  /** @deprecated */
  Basic = 'BASIC',
  /** @deprecated */
  Test = 'TEST',
  /** @deprecated */
  Premium1 = 'PREMIUM_1',

  Lite = 'LITE',
  Professional = 'PROFESSIONAL',
  Enterprise = 'ENTERPRISE'
}
const _ACCOUNT_ACCESS_TYPES = [
  { value: AccessTypes.Lite, label: 'Lite', displayOrder: 1 },
  { value: AccessTypes.Professional, label: 'Professional', displayOrder: 2 },
  { value: AccessTypes.Enterprise, label: 'Enterprise', displayOrder: 3 }
];

if(isFeatureEnabled(Features.Plg) && !isProductionEnv()) {
  if(!isFeatureEnabled(Features.PlgExternal3)) {
    _ACCOUNT_ACCESS_TYPES.push({
      value: AccessTypes.Premium1,
      label: 'Premium',
      displayOrder: 4
    });
  }
}

export const ACCOUNT_ACCESS_TYPES = [
  ..._ACCOUNT_ACCESS_TYPES
];

export const isAccessTypeEnterprise = (accessType: AccessTypes): boolean => {
  if (!isFeatureEnabled(Features.PlgExternal)) {
    console.info(`isAccessTypeEnterprise ${BlockedByFeature}`);
    return false;
  }
  const enterpriseAccessTypes = [AccessTypes.Premium1, AccessTypes.Enterprise, AccessTypes.Basic];
  const enterpriseAndProfessional = [...enterpriseAccessTypes, AccessTypes.Professional];
  return enterpriseAndProfessional.includes(accessType);
};

export const isAccessTypeLite = (accessType: AccessTypes): boolean => {
  if (!isFeatureEnabled(Features.PlgExternal)) {
    console.info(`isAccessTypeLite ${BlockedByFeature}`);
    return false;
  }
  return AccessTypes.Lite === accessType;
};
